<button
  [type]="type"
  [disabled]="disabled"
  [ngClass]="classes"
  class="inline-flex  items-center gap-2 border border-sky-700 bg-white px-3 py-2 font-medium leading-4 text-sky-800"
>
  <ng-content></ng-content>
</button>
